import { MetaTagFragment } from '@custom/schema';

export type MetaTags = {
  title?: string;
  links?: Array<{
    rel: string;
    href: string;
  }>;
  meta?: Array<{
    name?: string;
    content: string;
    property?: string;
  }>;
};
export const transformMetatagToHeadProps = (
  metatags?: MetaTagFragment[],
): MetaTags => {
  if (!metatags) {
    return {};
  }
  const title = metatags
    .filter(
      ({ tag, attributes }) => tag === 'meta' && attributes?.name === 'title',
    )
    .pop();
  const links = metatags.filter(({ tag }) => tag === 'link');
  const meta = metatags.filter(({ tag }) => tag === 'meta');

  return {
    title: title?.attributes?.content,
    links: links.map(({ attributes }) => ({
      rel: attributes?.rel || '',
      href: attributes?.href || '',
    })),
    meta: meta.map(({ attributes }) => ({
      name: attributes?.name,
      content: attributes?.content || '',
      property: attributes?.property,
    })),
  };
};
